import { render, staticRenderFns } from "./TheIntegrationsBox.vue?vue&type=template&id=36c44a62&scoped=true"
import script from "./TheIntegrationsBox.vue?vue&type=script&lang=js"
export * from "./TheIntegrationsBox.vue?vue&type=script&lang=js"
import style0 from "./TheIntegrationsBox.vue?vue&type=style&index=0&id=36c44a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c44a62",
  null
  
)

export default component.exports